module.exports = __webpack_public_path__ + "img/accumulator-charge-animation.31815acc.png";